import React from "react";
import { Link } from "react-router-dom";

export default function Header() {
  return (
    <div className="d-flex text-white justify-content-between align-items-center">
      <Link to="/">
        <h5 className="fw-bold m-0">codeindica</h5>
      </Link>
      <div className="d-flex justify-content-end align-items-center">
        <Link to="/work">
          <span>Work</span>
        </Link>

        <Link to="/inspiration">
          <span className="px-2">Inspiration</span>
        </Link>
        <Link to="/contact">
          <span>Contact</span>
        </Link>
      </div>
    </div>
  );
}
